































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import { CSSStyleOptions, VueRenderFunction } from '@libs/unified-ui-framework/src/shared/common-types';

/**
 * @event click `(event: MouseEvent)`
 */
@Component({
  components: {
    SwIcon,
  },
})
export default class SwDefconTab extends SwExtendedVue {
  @Prop({ type: [String, Function], default: '' })
  text: string | VueRenderFunction;

  @Prop({ default: false })
  selected: boolean;

  @Prop({ default: '#ff791a' })
  tabColor: string;

  @Prop({ default: false })
  noBorder: boolean;

  cssPrefix: string = 'sw-defcon-tab';

  isOnIcon: boolean = false;

  get iconStyle(): CSSStyleOptions {
    return {
      backgroundColor: (this.selected || this.isOnIcon) ? this.tabColor : '#000000',
      color: (this.isOnIcon || this.selected || this.noBorder) ? '#000000' : '#ffffff',
    };
  }

  onMouseEnterIcon() {
    this.isOnIcon = true;
  }

  onMouseLeaveIcon() {
    this.isOnIcon = false;
  }

  onClickIcon(event: MouseEvent) {
    if (!this.noBorder) {
      this.$emit('click', event);
    }
  }

  onClickOuter(event: MouseEvent) {
    if (this.noBorder) {
      this.$emit('click', event);
    }
  }
}
